import React from "react";

export function BreadcrumbKegiatan() {
    return (
        <>
            <section className="page-header">
                <div className="background-dark">
                    <div className="tim-container">
                        <div className="page-header-title text-center text-light">
                            <h3>Detail Kegiatan</h3>
                            <h2> Kegiatan</h2>
                        </div>

                        <div className="breadcrumbs text-light">
                            <a href="/" className="text-light">
                                Home
                            </a>
                            <span>&nbsp; / &nbsp;</span>
                            <span>Kegiatan</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export function BreadcrumbBlog() {
    return (
        <>
            <section className="page-header">
                <div className="background-dark">
                    <div className="tim-container">
                        <div className="page-header-title text-center text-light">
                            <h3>Detail Blog</h3>
                            <h2>& Blog</h2>
                        </div>

                        <div className="breadcrumbs text-light">
                            <a href="/" className="text-light">
                                Home
                            </a>
                            <span>&nbsp; / &nbsp;</span>
                            <span>Blog</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export function BreadcrumbAbout() {
    return (
        <>
            <section className="page-header-about">
                <div className="background-dark">
                    <div className="tim-container">
                        <div className="breadcrumbs text-light">
                            <a href="/" className="text-light">
                                Home
                            </a>
                            <span>&nbsp; / &nbsp;</span>
                            <span>About</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
